import { createContext, useContext } from 'react';

import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { IOrdersListViewConfig } from '~/src/dash/views/campaigns/orders/OrdersListView/config';

interface IOrdersListContext {
  cfg: IOrdersListViewConfig;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
}

export const OrdersListContext = createContext({} as IOrdersListContext);
export const useOrdersListStore = (): IOrdersListContext => useContext(OrdersListContext);
